import { query } from '@confluence/query-preloader-tools/entry-points/graphql';

import { ModernizedBreadcrumbsQuery } from './ModernizedBreadcrumbsQuery.graphql';

export function preloadBreadcrumbsDropdown({
	spaceKey,
	contentId,
}: {
	spaceKey: string;
	contentId?: string;
}) {
	return query({
		/* @ts-expect-error -- http://go/cfe-use-relay-artifacts */
		query: ModernizedBreadcrumbsQuery,
		variables: {
			spaceKey,
			contentId,
			skipContent: !contentId,
		},
	});
}
